<template>
    <div class="dashboard-container">
        <!-- 顶部筛选区域 -->
        <div class="filter-section">
            <div class="filter-card">
                <div class="filter-content">
                    <div class="filter-item">
                        <span class="filter-label">车牌号筛选：</span>
                        <el-input v-model="filterPlateNumber" placeholder="请输入车牌号" clearable class="tech-input" />
                    </div>
                    <div class="filter-item">
                        <el-button type="primary" class="tech-btn query-btn" @click="handleFilter">
                            <i class="el-icon-search"></i>
                            查询
                        </el-button>
                        <el-button class="tech-btn reset-btn" @click="resetFilter">
                            <i class="el-icon-refresh"></i>
                            重置
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 数据加载状态 -->
        <div v-if="isLoading" class="loading-overlay">
            <div class="loading-spinner">
                <i class="el-icon-loading"></i>
                <p>数据加载中...</p>
            </div>
        </div>
        <!-- 地图和信息面板区域 -->
        <div class="main-content">
            <!-- 地图容器 -->
            <div class="map-container">
                <div id="map-container" class="map"></div>
            </div>

            <!-- 右侧信息面板 -->
            <div class="info-panel">
                <!-- 车辆列表 -->
                <div class="vehicle-list-card">
                    <div class="panel-header">
                        <span>车辆列表</span>
                        <span class="vehicle-count">({{ vehicles.length }})</span>
                    </div>
                    <div class="list-content">
                        <div v-for="vehicle in vehicles" :key="vehicle.id" class="vehicle-item"
                            :class="{ active: selectedVehicle && selectedVehicle.id === vehicle.id }"
                            @click="selectVehicle(vehicle)">
                            <div class="vehicle-main">
                                <div class="vehicle-info">
                                    <div class="vehicle-plate">{{ vehicle.CARCODE }}</div>
                                    <div class="vehicle-status" v-if="vehicle.alarmtype">
                                        <div class="status-dot" :class="vehicle.alarmtype"></div>
                                        <el-tag size="mini" class="status-tag">
                                            {{ vehicle.alarmtype }}
                                        </el-tag>
                                    </div>
                                </div>
                                <div class="vehicle-location">{{ vehicle.newaddress }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 车辆信息弹窗 -->
        <el-dialog :visible.sync="showVehicleDialog" title="车辆详细信息" width="600px" class="vehicle-dialog"
            :close-on-click-modal="false" @close="handleDialogClose">
            <div v-if="selectedVehicle" class="vehicle-detail">
                <div class="detail-section">
                    <h3 class="section-title">基本信息</h3>
                    <div class="detail-grid">
                        <div class="detail-item">
                            <span class="detail-label">车牌号：</span>
                            <span class="detail-value">{{ selectedVehicle.CARCODE }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">车辆状态：</span>
                            <span>{{ selectedVehicle.alarmtype || '--' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">SIM卡号：</span>
                            <span class="detail-value">{{ selectedVehicle.SIM }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">GPS编号：</span>
                            <span class="detail-value">{{ selectedVehicle.GPSCODE }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">所属企业：</span>
                            <span class="detail-value">{{ selectedVehicle.Company }}</span>
                        </div>
                    </div>
                </div>

                <div class="detail-section">
                    <h3 class="section-title">位置信息</h3>
                    <div class="detail-grid">
                        <div class="detail-item">
                            <span class="detail-label">当前位置：</span>
                            <span class="detail-value">{{ selectedVehicle.newaddress }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">上线状态：</span>
                            <span class="detail-value">
                                上线
                            </span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">最新定位时间：</span>
                            <span class="detail-value">{{ selectedVehicle.t }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">总里程：</span>
                            <span class="detail-value">{{ selectedVehicle.mileage }} km</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">当前速度：</span>
                            <span class="detail-value">{{ selectedVehicle.speed }} km/h</span>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog" class="tech-btn">关闭</el-button>
                <el-button type="primary" class="tech-btn" @click="closeDialog">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// 导入单一车辆图片
import vehicleIcon from '@/assets/images/car/drive.png'

export default {
    name: 'VehicleMapDashboard',
    data() {
        return {
            map: null, // 地图实例
            markers: [], // 标记点数组
            filterPlateNumber: '', // 车牌号筛选
            selectedVehicle: null, // 选中的车辆
            showVehicleDialog: false, // 控制弹窗显示
            vehicleIcon: vehicleIcon, // 单一车辆图标
            // 模拟车辆数据
            vehicles: [],
            mapLoaded: false, // 地图是否加载完成
            isLoading: false // 是否正在加载
        }
    },
    mounted() {
        this.initMap();
        this.getCarList()
    },
    methods: {
        // 获取车辆数据
        getCarList() {
            this.isLoading = true
            this.axios.post('ownCarAlarm/getTheVehicleLocation', { carCode: this.filterPlateNumber }).then(res => {
                if (res.data.code == 200) {
                    this.vehicles = res.data.data;
                    // 数据获取成功后添加标记
                    if (this.mapLoaded) {
                        this.addVehicleMarkers()
                    }
                    this.isLoading = false
                }
            }).catch(err => {
                this.isLoading = false
            })
        },
        // 创建地图
        createMap() {
            this.map = new AMap.Map('mapContainer', {
                zoom: 10, // 初始缩放级别
                center: [113.665412, 34.757975] // 初始中心点坐标（郑州）
            })
        },
        // 初始化地图
        initMap() {
            // 检查是否已加载高德地图API
            if (window.AMap) {
                this.createMap()
                return
            }

            // 加载高德地图API
            const key = '848339899dba3d2d51d092f4baaccf6f'
            const script = document.createElement('script')
            script.src = `https://webapi.amap.com/maps?v=2.0&key=${key}&plugin=AMap.Scale`
            script.onload = () => {
                this.mapLoaded = true
                this.createMap()
                this.getCarList()
            }
            script.onerror = () => {
                console.error('高德地图加载失败')
                // 即使地图加载失败，也获取车辆数据
                this.getCarList()
            }
            document.head.appendChild(script)
        },

        // 创建地图实例
        createMap() {
            try {
                // 初始化地图 - 使用深色科技风格
                this.map = new AMap.Map('map-container', {
                    zoom: 5,
                    center: [104.065735, 35.000074],
                    viewMode: '3D',
                    mapStyle: 'amap://styles/darkblue' // 深蓝色地图样式
                })

                this.mapLoaded = true
                console.log('地图初始化成功')

            } catch (error) {
                console.error('地图初始化失败:', error)
            }
        },

        // 添加车辆标记
        addVehicleMarkers() {
            if (!this.map) {
                console.error('地图未初始化')
                return
            }

            // 清除现有标记
            this.clearMarkers()

            // 为每辆车添加标记
            this.vehicles.forEach(vehicle => {
                // 检查坐标数据是否存在
                if (!vehicle.o || !vehicle.a) {
                    console.warn(`车辆 ${vehicle.CARCODE} 缺少坐标数据`)
                    return
                }

                try {
                    // 创建自定义标记内容 - 包含车牌号和车辆图标
                    const markerContent = this.createMarkerContent(vehicle)

                    // 创建标记 - 使用自定义内容
                    const marker = new AMap.Marker({
                        position: [vehicle.o, vehicle.a],
                        content: markerContent,
                        offset: new AMap.Pixel(-13, -30), // 调整偏移量
                        title: vehicle.CARCODE,
                        extData: vehicle
                    })

                    // 创建信息窗口内容
                    const infoWindow = new AMap.InfoWindow({
                        content: this.createInfoWindowContent(vehicle),
                        offset: new AMap.Pixel(0, -40)
                    })

                    // 添加点击事件
                    marker.on('click', () => {
                        this.selectVehicle(vehicle)
                        // infoWindow.open(this.map, marker.getPosition())
                    })

                    // 将标记添加到地图
                    this.map.add(marker)
                    this.markers.push(marker)

                } catch (error) {
                    console.error(`添加车辆 ${vehicle.CARCODE} 标记失败:`, error)
                }
            })

            // 调整地图视野
            this.adjustMapView()
        },

        // 调整地图视野
        adjustMapView() {
            if (!this.map || this.markers.length === 0) return

            if (this.markers.length === 1) {
                const marker = this.markers[0]
                this.map.setCenter(marker.getPosition())
                this.map.setZoom(12)
            } else if (this.markers.length > 0) {
                this.map.setFitView(this.markers)
            }
        },

        // 创建自定义标记内容（包含车牌号和车辆图标）
        createMarkerContent(vehicle) {
            // 如果图标加载失败，使用默认样式
            const iconHtml = this.vehicleIcon ?
                `<img src="${this.vehicleIcon}" style="width: 26px; height: 40px; object-fit: contain;" />` :
                `<div style="width: 26px; height: 40px; background: #1890ff; border-radius: 4px;"></div>`

            return `
        <div style="position: relative; text-align: center; cursor: pointer;">
          <div style="position: absolute; top: -25px; left: 50%; transform: translateX(-50%); background: rgba(24, 144, 255, 0.95); color: white; padding: 3px 8px; border-radius: 4px; font-size: 12px; font-weight: bold; white-space: nowrap; border: 1px solid #ffffff; box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5); z-index: 1000;">
            ${vehicle.CARCODE}
          </div>
          ${iconHtml}
        </div>
      `
        },

        // 创建信息窗口内容（显示车牌号）
        createInfoWindowContent(vehicle) {
            return `
        <div class="custom-info-window">
          <div class="info-plate">${vehicle.CARCODE}</div>
          <div class="info-status">${vehicle.alarmtype}</div>
          <div class="info-address">${vehicle.newaddress}</div>
          <div class="info-speed">速度: ${vehicle.speed} km/h</div>
        </div>
      `
        },

        // 清除所有标记
        clearMarkers() {
            if (this.map && this.markers.length > 0) {
                this.map.remove(this.markers)
                this.markers = []
            }
        },

        // 选择车辆
        selectVehicle(vehicle) {
            this.selectedVehicle = vehicle
            this.showVehicleDialog = true

            // 定位到选中的车辆
            if (this.map && vehicle.o && vehicle.a) {
                this.map.setCenter([vehicle.o, vehicle.a])
                this.map.setZoom(15)
            }
        },

        // 关闭弹窗
        closeDialog() {
            this.showVehicleDialog = false
            this.selectedVehicle = null
        },

        // 处理弹窗关闭事件
        handleDialogClose() {
            this.selectedVehicle = null
        },

        // 处理筛选
        handleFilter() {
            this.getCarList()
        },

        // 重置筛选
        resetFilter() {
            this.filterPlateNumber = ''
            this.getCarList()
        },
    },
    beforeDestroy() {
        if (this.map) {
            this.map.destroy()
        }
    }
}
</script>

<style scoped>
.dashboard-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #0f1429;
}

/* 筛选区域 */
.filter-section {
    padding: 20px;
}

.filter-card {
    background: #1a223f;
    border: 1px solid #2d3a5a;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.filter-content {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
}

.filter-item {
    display: flex;
    align-items: center;
}

.filter-label {
    font-size: 14px;
    color: #a0a8c3;
    margin-right: 12px;
    white-space: nowrap;
}

.tech-input {
    width: 200px;
}

.tech-input>>>.el-input__inner {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid #2d3a5a;
    color: #ffffff;
    border-radius: 6px;
}

.tech-input>>>.el-input__inner::placeholder {
    color: #a0a8c3;
}

.tech-input>>>.el-input__inner:focus {
    border-color: #1890ff;
}

.tech-btn {
    border-radius: 6px;
    border: 1px solid #2d3a5a;
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    transition: all 0.3s;
}

.tech-btn:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: #1890ff;
}

.query-btn {
    background: #1890ff;
    border-color: #1890ff;
}

.query-btn:hover {
    background: #40a9ff;
    border-color: #40a9ff;
}

/* 主内容区域 */
.main-content {
    flex: 1;
    display: flex;
    padding: 0 20px 20px;
    gap: 20px;
    overflow: hidden;
}

.map-container {
    flex: 1;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    position: relative;
}

.map {
    width: 100%;
    height: 100%;
    min-height: 500px;
}

/* 信息面板 */
.info-panel {
    width: 450px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* 车辆列表 */
.vehicle-list-card {
    flex: 1;
    background: #1a223f;
    border: 1px solid #2d3a5a;
    /* border-radius: 8px; */
    padding: 20px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    font-weight: bold;
    font-size: 16px;
    color: #fff;
}

.vehicle-count {
    color: #a0a8c3;
    font-size: 14px;
}

.list-content {
    flex: 1;
    overflow-y: auto;
    max-height: 700px;
}

.vehicle-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px;
    border-bottom: 1px solid #2d3a5a;
    cursor: pointer;
    transition: all 0.3s;
    margin-bottom: 8px;
    /* border-radius: 6px; */
}

.vehicle-item:hover {
    background: #2a3655;
}

.vehicle-item.active {
    background: #1890ff;
    border-left: 4px solid #ffaa00;
}

.vehicle-main {
    flex: 1;
}

.vehicle-plate {
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 4px;
}

.vehicle-location {
    display: inline-block;
    width: 390px;
    font-size: 12px;
    color: #a0a8c3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.vehicle-status {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 10px;
}

.status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #faad14;
}

.status-dot.normal {
    background: #00d4aa;
}

.status-dot.warning {
    background: #faad14;
}

.status-dot.offline {
    background: #ff4d4f;
}

.status-tag {
    max-width: 260px;
    border: none;
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 图例 */
.map-legend {
    position: absolute;
    bottom: 20px;
    left: 20px;
    background: #1a223f;
    border: 1px solid #2d3a5a;
    padding: 15px;
    border-radius: 8px;
    z-index: 1000;
    min-width: 120px;
}

.legend-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #ffffff;
}

.legend-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.legend-icon {
    width: 20px;
    height: 30px;
    margin-right: 8px;
    object-fit: contain;
}

.legend-text {
    font-size: 12px;
    color: #a0a8c3;
}

/* 弹窗样式 */
.vehicle-dialog>>>.el-dialog {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.vehicle-dialog>>>.el-dialog__header {
    background: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
    padding: 20px;
    border-radius: 8px 8px 0 0;
}

.vehicle-dialog>>>.el-dialog__title {
    color: #303133;
    font-weight: bold;
}

.vehicle-dialog>>>.el-dialog__body {
    padding: 30px;
    background: #ffffff;
}

.vehicle-dialog>>>.el-dialog__footer {
    background: #f5f7fa;
    border-top: 1px solid #e4e7ed;
    padding: 20px;
    border-radius: 0 0 8px 8px;
}

.vehicle-detail {
    color: #606266;
}

.detail-section {
    margin-bottom: 30px;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #1890ff;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e4e7ed;
}

.detail-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
}

.detail-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
}

.detail-label {
    color: #909399;
    font-size: 14px;
    min-width: 80px;
}

.detail-value {
    color: #303133;
    font-size: 14px;
    flex: 1;
}

.dialog-footer .tech-btn {
    color: #606266;
}

.dialog-footer .tech-btn:first-child {
    background: transparent;
    border-color: #dcdfe6;
}

.dialog-footer .tech-btn:first-child:hover {
    background: #f5f7fa;
    border-color: #c0c4cc;
}

.dialog-footer .tech-btn:last-child {
    background: #1890ff;
    border-color: #1890ff;
    color: #ffffff;
}

.dialog-footer .tech-btn:last-child:hover {
    background: #40a9ff;
    border-color: #40a9ff;
}

/* 自定义信息窗口样式 */
.custom-info-window {
    background: #1a223f;
    border: 1px solid #2d3a5a;
    border-radius: 6px;
    padding: 8px 12px;
    color: #ffffff;
    min-width: 180px;
}

.info-plate {
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 4px;
}

.info-status {
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 4px;
    display: inline-block;
    background: #00d4aa;
    color: white;
    margin-bottom: 4px;
}

.info-address {
    font-size: 12px;
    color: #a0a8c3;
    margin-bottom: 2px;
}

.info-speed {
    font-size: 12px;
    color: #a0a8c3;
}

/* 滚动条样式 */
.list-content::-webkit-scrollbar {
    width: 6px;
}

.list-content::-webkit-scrollbar-thumb {
    background: #2d3a5a;
    border-radius: 3px;
}

.list-content::-webkit-scrollbar-thumb:hover {
    background: #1890ff;
}
.vehicle-info {
    display: flex;
}
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
}

.loading-spinner {
    text-align: center;
    color: #fff;
}

.loading-spinner i {
    font-size: 40px;
    margin-bottom: 10px;
}
/deep/.amap-container img {
    width: 40px!important;
}
</style>